/* beibelle74 · 推广中心 · 2026-10-29
 * 数据全部来自 /referral-hook/rewards（文案 + 参数 + 余额都在这一个响应里）
 * 文案改了不用改代码：后台改完，这里拿到什么就渲染什么
 */
(function () {
  'use strict';

  var root = document.getElementById('bbr-root');
  if (!root) return;

  var API = (window.BB_API || '').replace(/\/$/, '');
  var ALT = (window.BB_API_ALT || '').replace(/\/$/, '');
  /* 记住上次能用的通道：老客户下次直接命中，不再先等主通道超时（"少跳一次"） */
  try {
    var _saved = localStorage.getItem('bb_api_base') || '';
    /* 备用通道换了域名（隧道重启）就丢弃旧记录，直接用新的 */
    if (/trycloudflare\.com/.test(_saved) && _saved !== ALT) _saved = '';
    if (_saved) { ALT = API; API = _saved; }
  } catch (e) {}
  var EMAIL = (root.getAttribute('data-email') || '').trim();
  /* IDENTITY-20261030：**没登录，但这台设备订阅过**（bb_newsletter 写的 bb_sub_email）
     ⇒ 用那个邮箱认领。后台的码本来就按邮箱返回，不看浏览器，所以不会给错人；
     共用电脑最多看到对方链接（对方受益、本人不损），比"订阅完还让他 Sign in once"划算。
     🔴 认领时**不再触发订阅**（见 fillLink 里的 subscribe: !GUEST_CLAIM）——
        订阅许可是客户自己点出来的，不能因为他来过这一页再替他确认一次。 */
  var GUEST_CLAIM = '';
  if (!EMAIL) {
    try { GUEST_CLAIM = (localStorage.getItem('bb_sub_email') || '').trim().toLowerCase(); } catch (e) {}
    if (GUEST_CLAIM.indexOf('@') < 1) GUEST_CLAIM = '';
    if (GUEST_CLAIM) EMAIL = GUEST_CLAIM;
  }
  var DEFAULT_PCT = parseInt(root.getAttribute('data-pct') || '10', 10);

  var S = { data: null, zip: '', qty: 0, maxQty: 0, left: 0, busy: false, copy: {}, params: {} };

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function money(n) { return '$' + Number(n || 0).toFixed(2); }
  function short(n) { n = Number(n || 0); return '$' + (n % 1 === 0 ? n : n.toFixed(2)); }

  function fmt(tpl, vars) {
    if (!tpl) return '';
    return String(tpl).replace(/\{(\w+)\}/g, function (m, k) {
      return (vars && vars[k] !== undefined && vars[k] !== null) ? vars[k] : m;
    });
  }

  /* ---------------- 网络 ----------------
     两条通道：主通道 erp.beibelle74.com，备用通道走 Cloudflare（BB_API_ALT）。
     原因：部分网络环境到国内服务器的直连会被掐断（2026-10-29 实测有客户遇到），
     Cloudflare 边缘全球可达，主通道失败就自动切过去，并记住已切换。
     ⚠️ 超时必须按后端真实耗时给：建码要调 Shopify GraphQL，1.8s 起。            */
  function once(base, path, opts) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, opts.timeout || 10000);
    var conf = { method: opts.method || 'GET', headers: { 'Content-Type': 'application/json' }, cache: 'no-store' };
    if (ctrl) conf.signal = ctrl.signal;
    if (opts.body) conf.body = JSON.stringify(opts.body);
    return fetch(base + path, conf).then(function (r) {
      clearTimeout(timer);
      return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; });
    }, function (e) { clearTimeout(timer); throw e; });
  }

  function req(path, opts) {
    opts = opts || {};
    /* 主通道只等 6 秒（建码实测 1.8s，足够）；连不上就换备用，客户不用干等 10 秒 */
    var p1 = { method: opts.method, body: opts.body, timeout: Math.min(opts.timeout || 10000, 6000) };
    return once(API, path, p1).catch(function (e) {
      if (!ALT || ALT === API) throw e;
      /* 主通道连不上（不是业务报错）→ 走备用通道，成功了就固定用它 */
      return once(ALT, path, opts).then(function (r) {
        API = ALT;
        try { localStorage.setItem('bb_api_base', API); } catch (e) {}
        return r;
      });
    });
  }

  /* ---------------- 文案 ---------------- */
  function vars(extra) {
    var p = S.params || {};
    var base = {
      pct: S.data ? S.data.reward_pct : DEFAULT_PCT,
      cap: p.per_friend_cap || 2,
      free: p.free_ship_min || 100,
      limit: p.max_per_claim || 100,
      zip: S.zip || '—'
    };
    if (extra) for (var k in extra) base[k] = extra[k];
    return base;
  }

  function paintCopy() {
    var v0 = vars();
    $$('[data-copy]').forEach(function (el) {
      /* #bbr-note 的文案由 render / 报价实时决定（运费、锁定说明），
         不能被静态文案覆盖，否则会露出未替换的 {n} 模板 */
      if (el.id === 'bbr-note') return;
      var v = S.copy[el.getAttribute('data-copy')];
      if (v === undefined || v === null || v === '') return;
      el.textContent = fmt(v, v0);          /* 没有占位符的文案 fmt 原样返回 */
    });
  }

  /* ---------------- 主渲染 ---------------- */
  function render() {
    var d = S.data;
    if (!d) return;
    S.copy = d.copy || {};
    if (d.share_code) { S.code = d.share_code; preloadPoster(); }
    S.params = d.params || {};

    var g = d.gift || {};
    var claim = d.claim;
    var avail = g.available || 0;
    var locked = g.locked || 0;          /* 已付款未签收：看得见，领不了 */
    var maxPer = g.max_per_claim || parseInt(S.params.max_per_claim || 100, 10);
    S.left = avail;
    S.maxQty = Math.min(avail, maxPer);

    /* STATS-OFF-20261031：上面那两个统计格已删 ——
       「Free cards」和下面大卡的「N free cards」是同一个数，
       「Friends」在下面的「Your friends」表里逐个列着。*/

    // 进度：分母是"已赚"
    var earned = Math.max(1, g.earned || 0);
    setStyle('[data-k="bar-used"]', 'width', ((g.claimed || 0) / earned * 100) + '%');
    setStyle('[data-k="bar-left"]', 'width', (avail / earned * 100) + '%');
    setText('[data-k="lg-left"]', g.available + ' to claim');
    setText('[data-k="lg-used"]', (g.claimed || 0) + ' claimed');

    // 大卡状态
    var st = $('#bbr-gift');
    st.classList.toggle('is-dim', (avail === 0 && !claim && locked === 0) || (g.earned === 0));
    /* 2026-10-31：一张都没赚到时收起进度条与图例（全是 0，白占一大块黑） */
    st.classList.toggle('is-zero', (g.earned || 0) === 0 && !claim);

    var stateTx = S.copy['state_ready'];
    if (g.earned === 0) stateTx = S.copy['state_none'];
    else if (claim) stateTx = S.copy['state_reserved'];
    else if (avail === 0 && locked > 0) stateTx = S.copy['state_locked'];
    else if (avail === 0) stateTx = S.copy['state_claimed'];
    setText('[data-k="state"]', stateTx);

    /* 大卡数字：有可领显示可领；全锁着显示锁定张数（别显示 0 让人以为白干了） */
    var shown = claim ? claim.qty : (avail > 0 ? avail : locked);
    setText('[data-k="gift-n"]', shown);
    setText('[data-k="gift-unit"]', shown === 1 ? 'card' : 'cards');
    paintStack(shown);        /* 锁定态也要画出卡背，别显示 1 张让人以为没卡 */

    // 按钮
    var btn = $('#bbr-main'), alt = $('#bbr-alt'), note = $('#bbr-note');
    btn.classList.remove('is-free');
    alt.hidden = true;
    note.hidden = false;

    if (d.signed_in === false) {
      /* 未登录：不给他"分享一个拿不到奖励的链接"的机会，先登录（登录即绑定+订阅） */
      btn.textContent = S.copy['btn_signin'] || 'Get my link';
      btn.setAttribute('data-act', 'signin');
      note.textContent = S.copy['signin_hint'] || 'One sign-in. Your link is ready in a second.';
      note.hidden = false;
    } else if (g.earned === 0) {
      /* 2026-10-31 侯哥：「提卡的按钮去哪里了？即使还没获得卡，按钮也得在，点了给提示」
         ⇒ 这张大卡的主按钮**永远提卡**，不再变回「分享我的链接」（那跟顶上那颗重复）。
         0 卡时按钮照常可点，点一下弹 toast，不然它看着像坏了。 */
      btn.disabled = false;
      btn.textContent = S.copy['btn_claim_none'] || 'Claim cards';
      btn.setAttribute('data-act', 'noClaim');
      note.textContent = S.copy['note_none'] || 'No free cards yet — share your link and they show up here.';
      note.hidden = false;
    } else if (claim) {
      var cs = Number(claim.shipping || 0);
      btn.textContent = cs > 0 ? ('Pay ' + money(cs) + ' shipping') : 'Confirm free shipping';
      btn.setAttribute('data-act', 'pay');
      note.textContent = cs > 0 ? ('Held ' + (S.params.claim_expire_days || 7) + ' days · ' + money(cs) + ' shipping due')
                                : ('Free shipping · ' + claim.qty + ' cards in one order');
    } else if (avail === 0 && locked > 0) {
      /* 锁定态：外观仍是"提卡"，但点下去只解释原因（禁用看着像坏了，侯哥明确要可点+提示） */
      btn.disabled = false;
      btn.textContent = fmt(S.copy['btn_locked'] || '{n} cards unlock on delivery', { n: locked });
      btn.setAttribute('data-act', 'lockedInfo');
      note.textContent = S.copy['note_locked'] || "They've paid. Cards unlock when the order is delivered.";
    } else if (avail === 0) {
      btn.disabled = false;
      btn.textContent = S.copy['btn_claim_none'] || 'Claim cards';
      btn.setAttribute('data-act', 'noClaim');
      note.textContent = S.copy['note_claimed'] || 'All claimed. The next friend you bring earns you more.';
    } else {
      btn.disabled = false;
      alt.hidden = false;
      btn.setAttribute('data-act', 'claimAll');
      S.qty = S.maxQty;
      quoteAndLabel();
    }

    // 记录表
    var hasHist = (d.history || []).length > 0;
    var tbl = $('.bbr-table');
    if (tbl) tbl.classList.toggle('is-empty', !hasHist);
    var tb = $('[data-k="history"]');
    if (tb) {
      var rows = (d.history || []).map(function (h) {
        var when = (h.created_at || '').slice(0, 10);
        var free = h.status === 'void' ? '—'
          : (h.status === 'available' ? ('+' + (h.cards_grant || 0))
          : (h.status === 'locked' ? ('\uD83D\uDD12 ' + (h.cards_grant || 0)) : ('+' + (h.cards_grant || 0))));
        return '<div class="bbr-row"><div class="bbr-who">' + esc(h.friend_email || h.order_name || '—') +
          '<small>' + esc(when) + '</small></div><div class="bbr-c">' + (h.cards_bought || 0) +
          '</div><div class="bbr-c g">' + esc(free) + '</div></div>';
      }).join('');
      tb.innerHTML = rows || '<div class="bbr-empty">No friends yet — send your link to start earning.</div>';
    }

    paintCopy();
    updateSummary();

    /* 未登录：说明"余额要登录才看得到"，别让三格 0 看着像坏了 */
    var bootBox = $('#bbr-boot');
    if (bootBox && !S.failed) {
      if (d.signed_in === false) {
        bootBox.hidden = false;
        bootBox.innerHTML = '<div class="bbr-err">'
          + esc(S.copy['guest_notice'] || 'Sign in to see your own balance. Your link and code are created the moment you sign in.')
          + '</div>';
      } else {
        bootBox.hidden = true;
        bootBox.innerHTML = '';
      }
    }
  }

  function updateSummary() {
    if (!S.data) return;
    var g = S.data.gift || {};
    setText('[data-k="sum-earned"]', g.earned || 0);
    setText('[data-k="sum-claimed"]', g.claimed || 0);
    setText('[data-k="sum-left"]', g.available || 0);
  }

  /* ---------------- 报价（张数 / 邮编一变就重算） ---------------- */
  function quoteAndLabel() {
    var btn = $('#bbr-main'), note = $('#bbr-note');
    var qty = S.qty || S.maxQty;
    if (!qty) return;
    btn.disabled = true;
    req('/rewards/quote?qty=' + qty + '&zip=' + encodeURIComponent(S.zip || ''))
      .then(function (r) {
        /* 2026-10-30 修：报价失败（500/超时/返回体不对）原来会被当成 shipping=0
           ⇒ 按钮直接显示 "Free shipping"，客户结账才发现要付 $6.50。报价不可信就抛错。 */
        if (!r.ok || !r.data || typeof r.data.shipping !== 'number') throw new Error('quote');
        var p = r.data.shipping;
        var free = p === 0;
        if (free) {
          btn.innerHTML = fmt(S.copy['btn_claim_all'], { n: qty, amt: '' }).replace(/·\s*$/, '· <b class="bbr-free">' + esc(S.copy['btn_free']) + '</b>');
          btn.classList.add('is-free');
          note.innerHTML = fmt(S.copy['note_free'], { n: qty });
        } else {
          var tpl = qty >= S.left ? S.copy['btn_claim_all'] : S.copy['btn_claim_some'];
          btn.textContent = fmt(tpl, { n: qty, amt: short(p) });
          if (S.left > qty) {
            note.textContent = fmt(S.copy['note_limit'], { n: S.left - qty, limit: S.maxQty });
          } else if (S.left >= 50) {
            note.textContent = fmt(S.copy['note_upsell'], { n: (S.params.free_ship_min || 100) - S.left });
          } else {
            note.innerHTML = fmt(esc(S.copy['note_ship']), { zip: '<button type="button" class="bbr-zip" id="bbr-zip">' + esc(S.zip || 'set ZIP') + '</button>', n: qty });
            bindZip();
          }
        }
        btn.disabled = false;
      })
      .catch(function () { btn.disabled = false; note.textContent = 'Shipping unavailable · retry'; });
  }

  function bindZip() {
    var z = $('#bbr-zip');
    if (!z) return;
    z.onclick = function () {
      var cur = S.zip || '';
      var v = window.prompt('Shipping ZIP code (5 digits)', cur);
      if (v == null) return;
      v = String(v).replace(/\D/g, '').slice(0, 5);
      if (v.length !== 5) { return; }
      S.zip = v;
      try { localStorage.setItem('bb_gift_zip', v); } catch (e) {}
      quoteAndLabel();
    };
  }

  /* ---------------- 卡背 ---------------- */
  function paintStack(n) {
    var box = $('[data-k="stack"]');
    if (!box) return;
    var cls = ['a', 'b', 'c', 'd', 'e'];
    box.innerHTML = '';
    if (n <= 0) {
      /* GIFTCARD-REDESIGN：空态画**三个**虚线卡位（原来只画一张半透明暗卡，像加载失败） */
      ['a', 'b', 'c'].forEach(function (k) {
        var e = document.createElement('div');
        e.className = 'bbr-cb ph ' + k;
        box.appendChild(e);
      });
      return;
    }
    for (var i = 0; i < Math.max(1, Math.min(n, 5)); i++) {
      var d = document.createElement('div');
      d.className = 'bbr-cb ' + cls[i];
      box.appendChild(d);
    }
  }

  /* ---------------- 领取 ---------------- */
  function doClaim(qty) {
    if (S.busy) return;
    S.busy = true;
    var btn = $('#bbr-main');
    var old = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Creating your gift order…';
    req('/gift/claim', { method: 'POST', timeout: 60000, body: { email: EMAIL, qty: qty, zip: S.zip || '' } })
      .then(function (r) {
        S.busy = false;
        if (!r.ok) {
          btn.disabled = false; btn.textContent = old;
          var msg = (r.data && r.data.error) || 'Could not create the order';
          if (/nothing to claim/i.test(msg)) msg = 'No cards ready to claim right now';
          else if (/disabled/i.test(msg)) msg = 'Claiming is paused — please try later';
          else if (/^create failed/i.test(msg)) msg = 'Could not create the gift order — please try again';
          toast(msg);
          return;
        }
        var url = r.data.invoice_url;
        toast('Gift order ready — redirecting…');
        setTimeout(function () { window.location.href = url; }, 600);
      })
      .catch(function () {
        S.busy = false;
        btn.disabled = false; btn.textContent = old;
        toast('Network error · try again');
      });
  }

  /* ---------------- 交互绑定 ---------------- */
  function bind() {
    var btn = $('#bbr-main');
    if (btn) {
      btn.onclick = function () {
        var act = btn.getAttribute('data-act');
        if (act === 'claimAll') return doClaim(S.maxQty);
        if (act === 'pay') return doClaim(S.qty || 0);
        if (act === 'share') return openShare();
        /* 2026-10-31：提卡按钮的三种"领不到"状态，点一下必须有人回话 */
        if (act === 'noClaim') return toast(S.copy['toast_no_cards']
          || 'No free cards yet — share your link to start earning.');
        if (act === 'lockedInfo') return toast(S.copy['toast_locked']
          || "Unlocks when your friend's order is delivered.");
        if (act === 'signin') return goSignIn();
      };
    }
    var alt = $('#bbr-alt');
    if (alt) alt.onclick = openPicker;
    /* 分享按钮统一在这里绑 —— fillLink 在未登录时会提前 return，别把绑定漏掉 */
    var sbtn = $('#bbr-share');
    if (sbtn) sbtn.onclick = openShareSheet;
    /* 关闭类一次绑死：弹层可能因各种原因被打开（含 QA/异常），不能依赖打开路径去挂 */
    var x2 = $('#bbrShX2'); if (x2) x2.onclick = closeShareSheet;
    var cl0 = $('#bbrShClose'); if (cl0) cl0.onclick = closeShareSheet;
    var sc0 = $('#bbrShScrim'); if (sc0) sc0.onclick = closeShareSheet;
  }

  /* ---------------- 分享弹层 ---------------- */
  function shareUrl() {
    var el = $('#bbrShLink');
    return (el && el.textContent.trim()) || S.link || '';
  }

  /* ---------------- 分享海报（2026-10-30 定稿 A 夜金） ----------------
     图由后端现出：/referral-hook/poster?c=推荐码。二维码里烧的就是这个码，
     朋友扫进来直接落在带折扣的落地页，归属能追到人。
     🔴 没拿到码时绝不出图 —— 一张归不到人的海报等于白送流量。*/
  function posterUrl(fmt) {
    var c = S.code || '';
    if (!c) return '';
    var u = API.replace(/\/$/, '') + '/poster?c=' + encodeURIComponent(c);
    if (fmt && fmt !== 'jpeg') u += '&fmt=' + fmt;
    /* POSTER-VER-20261031：版式一改（后端 poster.VERSION）URL 就跟着变，
       否则浏览器里那张旧海报会被长按保存、被缓存 1 小时 */
    var pv = (S.data && S.data.poster_ver) || '';
    if (pv) u += '&v=' + encodeURIComponent(pv);
    return u;
  }

  /* 把图片当文件发出去（客户点一次就发到 WhatsApp/IG）；
     端上不支持文件分享就打开图片页，让客户长按保存 —— 两条路都能走通。*/
  function shareImage() {
    var u = posterUrl();
    var openIt = function () { if (u) window.open(u, '_blank', 'noopener'); };
    if (!u) return openIt();
    if (!window.fetch || !navigator.share || !navigator.canShare) return openIt();
    fetch(u, { cache: 'force-cache' })
      .then(function (r) { return r.blob(); })
      .then(function (b) {
        var f = new File([b], 'beibelle74-free-cards.jpg', { type: 'image/jpeg' });
        if (navigator.canShare({ files: [f] })) {
          return navigator.share({ files: [f], text: shareText() }).catch(function () {});
        }
        openIt();
      })
      .catch(openIt);
  }

  /* 两条路切换：图片面板 / 链接面板 */
  function showPane(which) {
    var img = $('#bbrPaneImg'), link = $('#bbrPaneLink');
    var isLink = which === 'link';
    if (img) img.hidden = isLink;
    if (link) link.hidden = !isLink;
    $$('.bbr-tab').forEach(function (b) {
      var on = b.getAttribute('data-pane') === (isLink ? 'link' : 'img');
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    S.pane = isLink ? 'link' : 'img';
  }

  function bindTabs() {
    $$('.bbr-tab').forEach(function (b) {
      if (b.getAttribute('data-bound')) return;
      b.setAttribute('data-bound', '1');
      b.onclick = function () { showPane(b.getAttribute('data-pane')); };
    });
    var si = $('#bbrShImgShare');
    if (si && !si.getAttribute('data-bound')) {
      si.setAttribute('data-bound', '1');
      si.onclick = shareImage;
    }
    showPane(S.pane || 'img');
  }

  function applyPoster() {
    var img = $('#bbrShPoster');
    if (!img) return;
    var u = posterUrl();
    if (!u) { img.removeAttribute('src'); img.removeAttribute('data-src'); return; }
    if (img.getAttribute('data-src') !== u) {
      img.setAttribute('data-src', u);
      img.onload = function () {
        var box = img.parentNode;
        if (box) { box.classList.add('is-ready'); box.classList.remove('is-failed'); }
      };
      img.onerror = function () {
        var box = img.parentNode;
        if (box) box.classList.add('is-failed');
        /* 服务端偶尔重启/超时：3 秒后重试一次；再失败就明说让客户走链接分享，
           绝不能一直转骨架让人以为卡住（2026-10-30）*/
        if (!img.getAttribute('data-retried')) {
          img.setAttribute('data-retried', '1');
          setTimeout(function () {
            img.removeAttribute('src');
            img.removeAttribute('data-src');
            applyPoster();
          }, 3000);
        }
      };
      img.src = u;
    }
    if (img.getAttribute('src') && img.complete && img.naturalWidth) {
      var box2 = img.parentNode;
      if (box2) box2.classList.add('is-ready');
    }
    var a = $('#bbrShSave');
    if (a) a.href = u;
  }

  /* 拿到码就偷偷把图取回来（服务端首次出图 3~4s，等客户点开弹层再取＝先看到骨架）。
     force-cache：后面 applyPoster 用同一个 URL，直接命中浏览器缓存。*/
  function preloadPoster() {
    var u = posterUrl();
    if (!u || S.posterWarm === u) return;
    S.posterWarm = u;
    try {
      var im = new Image();
      im.decoding = 'async';
      im.src = u;
    } catch (e) {}
    if (window.fetch) { try { fetch(u, { cache: 'force-cache' }).catch(function () {}); } catch (e) {} }
  }

  /* 分享文案（收件人视角，NO-20-20261101）：
     ① 卡稀缺，值得一看；② **不再提任何折扣**（全站只有订阅 10%，分享不额外给折扣）；
     ③ 免费卡只来自「你自己也去分享」。
     🔴 永久禁用句式："Free cards for your first order"（会被读成买卡免费）、"20% off your first order"（已于 2026-11-01 取消）。*/
  function shareText() {
    return "Fan art cards you won't find in stores. Share your own link and you earn free cards — up to 2 per friend.";
  }

  /* 一键：未登录直接跳登录（登录页本身就是邮箱入口，注册/登录同一页），
     登录回来带 ?share=1 => 自动 /bind 建码绑邮箱 => 自动把这个框弹回来。
     ⚠️ 绝不在这里先收一次邮箱 —— 那会让客户输两遍（2026-10-29 改） */
  function goSignIn() {
    var back = '/pages/rewards?share=1';
    try { localStorage.setItem('bb_pending_share', String(Date.now())); } catch (e) {}
    location.href = '/account/login?return_url=' + encodeURIComponent(back);
  }

  function openShareSheet() {
    if (!EMAIL) return goSignIn();
    /* 链接还没拿到（首次建码失败/还在重试）就先补拉一次，别弹出一个空链接框 */
    if (!S.link) {
      S.wantSheet = true;
      toast(S.copy['link_creating'] || 'Creating your link…');
      fillLink(null);
      return;
    }
    var sc = $('#bbrShScrim'), sh = $('#bbrShSheet');
    if (!sc || !sh) return;
    var sub = $('#bbrShSub');
    if (sub) sub.textContent = S.copy['share_sub_ready'] || sub.textContent;
    var lk = $('#bbrShLink');
    if (lk) lk.textContent = S.link || lk.textContent;
    bindShareTargets();
    applyPoster();
    bindTabs();
    clearTimeout(shareTimer);
    sc.classList.remove('off');
    sh.classList.remove('off');
    /* SHEET-MOTION-20261103：同样双 rAF，遮罩渐显 + 面板从屏外滑上来 */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sc.classList.add('on');
        sh.classList.add('on');
      });
    });
    document.body.classList.add('bbr-lock');
  }

  var shareTimer = null;
  function closeShareSheet() {
    var sc = $('#bbrShScrim'), sh = $('#bbrShSheet');
    if (sc) sc.classList.remove('on');
    if (sh) sh.classList.remove('on');
    document.body.classList.remove('bbr-lock');
    /* 等退出过渡走完再收成 display:none，否则又是「啪」一下消失 */
    clearTimeout(shareTimer);
    shareTimer = setTimeout(function () {
      if (sc) sc.classList.add('off');
      if (sh) sh.classList.add('off');
    }, 340);
  }

  function bindShareTargets() {
    var url = shareUrl();
    if (!url) return;
    var t = encodeURIComponent(shareText());
    var u = encodeURIComponent(url);
    var set = function (id, href) { var e = $('#' + id); if (e) e.setAttribute('href', href); };
    set('bbrShWa', 'https://wa.me/?text=' + t + '%20' + u);
    set('bbrShX', 'https://twitter.com/intent/tweet?text=' + t + '&url=' + u);
    set('bbrShFb', 'https://www.facebook.com/sharer/sharer.php?u=' + u);
    set('bbrShMail', 'mailto:?subject=' + encodeURIComponent("Fan art cards — you'll want to see these") + '&body=' + t + '%20' + u);

    var cp = $('#bbrShCopy');
    if (cp) cp.onclick = function () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { toast('Link copied'); },
                                                function () { toast('Copy failed'); });
      } else { toast(url); }
    };
    var nat = $('#bbrShNative');
    if (nat) {
      if (!navigator.share) { nat.hidden = true; }
      else nat.onclick = function () {
        /* 这是「分享链接」这一条路：只发链接 + 文案。
           发图走图片面板的 #bbrShImgShare（shareImage），两条路互不串（侯哥 2026-10-30 要求）。*/
        navigator.share({ title: 'beibelle74 — fan art cards', text: shareText(), url: url })
          .catch(function () {});
      };
    }
    var ig = $('#bbrShIg');
    if (ig) ig.onclick = function (ev) {
      ev.preventDefault();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          toast('Link copied - paste it in your story or bio');
        }, function () { toast(url); });
      } else { toast(url); }
    };
    var cl = $('#bbrShClose');
    if (cl) cl.onclick = closeShareSheet;
    var x2 = $('#bbrShX2');
    if (x2) x2.onclick = closeShareSheet;
    var sc2 = $('#bbrShScrim');
    if (sc2) sc2.onclick = closeShareSheet;
  }

  function openShare() {
    var link = $('#bbr-link');
    if (link && navigator.share) {
      navigator.share({ title: "beibelle74 — fan art cards", text: shareText(), url: link.textContent }).catch(function(){});
    } else if (link && navigator.clipboard) {
      navigator.clipboard.writeText(link.textContent).then(function () { toast('Link copied'); }, function () { toast('Copy failed'); });
    }
  }

  /* ---------------- 选张数弹层 ---------------- */
  function openPicker() {
    var max = S.maxQty;
    if (!max) return;
    var qty = Math.max(1, Math.min(S.qty || max, max));
    var shell = document.createElement('div');
    shell.className = 'bbr-scrim';
    shell.innerHTML =
      '<div class="bbr-sheet" role="dialog" aria-modal="true">' +
        '<div class="bbr-grab"></div>' +
        '<h4 data-copy="sheet_title">How many cards?</h4>' +
        '<div class="bbr-sub" data-k="pick-sub"></div>' +
        '<div class="bbr-qty"><button type="button" data-d="-1">−</button><span data-k="qv"></span><button type="button" data-d="1">+</button></div>' +
        '<div class="bbr-quick"><button type="button" data-set="1">1</button><button type="button" data-set="5">5</button><button type="button" data-set="10">10</button><button type="button" data-set="max">Max</button></div>' +
        '<div class="bbr-bill"><div><span data-k="lbl-cards"></span><span data-k="val-cards">$0.00</span></div>' +
        '<div><span>Shipping</span><span data-k="val-ship">—</span></div></div>' +
        '<div class="bbr-picknote">' + (S.copy['gift_random_short'] || 'Random cards. Images are placeholders — we pick what is in stock when packing.') + '</div>' +
        '<button type="button" class="bbr-submit" data-k="submit"></button>' +
        '<button type="button" class="bbr-cancel" data-copy="sheet_cancel">Cancel</button>' +
      '</div>';
    document.body.appendChild(shell);
    document.body.classList.add('bbr-lock');
    /* SHEET-MOTION-20261103：先让节点进布局，下一帧再加 .is-open，过渡才有起点
       （以前是 @keyframes 一次性播放，关闭 shell.remove() 直接消失、零退出动画） */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { shell.classList.add('is-open'); });
    });

    var closing = false;
    var close = function () {
      if (closing) return;
      closing = true;
      shell.classList.remove('is-open');
      document.body.classList.remove('bbr-lock');
      setTimeout(function () {
        if (shell.parentNode) shell.parentNode.removeChild(shell);
      }, 340);
    };
    shell.addEventListener('click', function (e) { if (e.target === shell) close(); });

    function refresh() {
      shell.querySelector('[data-k="qv"]').textContent = qty;
      shell.querySelector('[data-k="pick-sub"]').textContent = S.left + ' available · up to ' + max + ' per order';
      shell.querySelector('[data-k="lbl-cards"]').textContent = qty + ' × card';
      shell.querySelector('[data-k="submit"]').textContent = 'Calculating…';
      req('/rewards/quote?qty=' + qty + '&zip=' + encodeURIComponent(S.zip || ''))
        .then(function (r) {
          /* 同上：报价失败绝不能被渲染成 "Free" */
          if (!r.ok || !r.data || typeof r.data.shipping !== 'number') throw new Error('quote');
          var p = r.data.shipping;
          shell.querySelector('[data-k="val-ship"]').textContent = p === 0 ? 'Free' : money(p);
          shell.querySelector('[data-k="submit"]').textContent = fmt(S.copy['sheet_make'], { amt: p === 0 ? 'Free' : money(p) });
        })
        .catch(function () {
          shell.querySelector('[data-k="val-ship"]').textContent = '—';
          shell.querySelector('[data-k="submit"]').textContent = 'Retry';
        });
    }
    shell.querySelectorAll('[data-d]').forEach(function (b) {
      b.onclick = function () {
        var n = qty + parseInt(b.getAttribute('data-d'), 10);
        if (n < 1 || n > max) return;
        qty = n; refresh();
      };
    });
    shell.querySelectorAll('[data-set]').forEach(function (b) {
      b.onclick = function () {
        var v = b.getAttribute('data-set');
        qty = v === 'max' ? max : Math.min(parseInt(v, 10), max);
        refresh();
      };
    });
    shell.querySelector('[data-k="submit"]').onclick = function () { close(); doClaim(qty); };
    shell.querySelector('.bbr-cancel').onclick = close;
    var h4 = shell.querySelector('h4');
    if (h4 && S.copy['sheet_title']) h4.textContent = S.copy['sheet_title'];
    var cnc = shell.querySelector('.bbr-cancel');
    if (cnc && S.copy['sheet_cancel']) cnc.textContent = S.copy['sheet_cancel'];
    refresh();
  }

  function anonId() {
    var a = '';
    try { a = localStorage.getItem('bb_ref_id') || ''; } catch (e) {}
    if (!a) {
      a = 'bb' + Math.random().toString(36).slice(2, 12);
      try { localStorage.setItem('bb_ref_id', a); } catch (e) {}
    }
    return a;
  }

  /* IDENTITY-20261030：游客一旦认领成功，这一页不能还挂着"Sign in once"的锁态 ——
     客户明明已经有链接了。只有**真拿到后台 link** 才解锁；拿不到就保持原样（等于没改）。 */
  function unlockGuestUi() {
    if (!GUEST_CLAIM || !S.link) return;
    var el = $('#bbr-link');
    if (el) {
      el.classList.remove('is-locked');
      el.removeAttribute('data-copy');       // 别让后台文案再把这里刷回 "Sign in once"
      el.textContent = S.link;
    }
    var sg = $('#bbr-signin-mini');
    if (sg && sg.parentNode) {
      var b = document.createElement('button');
      b.className = 'bbr-mini';
      b.type = 'button';
      b.textContent = (S.copy && S.copy['btn_copy']) || 'Copy';
      b.onclick = function () {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(S.link).then(function () { toast('Link copied'); },
            function () { toast(S.link); });
        } else { toast(S.link); }
      };
      sg.parentNode.replaceChild(b, sg);
    }
    /* 🔴 文案必须一起换：链接都已经生效了，按钮还写着「Get my link」= 客户以为没拿到，
       会再点一次（那一次还会去登录）。2026-10-30 真机实测抓到，必须一起改。 */
    var btnShare = (S.copy && S.copy['btn_share']) || 'Share my link';
    var main = $('#bbr-main');
    if (main) {
      main.setAttribute('data-act', 'share');
      main.setAttribute('data-copy', 'btn_share');   // 后台文案刷新时也别刷回 signin
      main.textContent = btnShare;
    }
    var sh = $('#bbr-share');
    if (sh) {
      sh.setAttribute('data-copy', 'btn_share');
      sh.textContent = btnShare;
    }
    var note = document.querySelector('#bbr-root .bbr-bindnote');
    if (note) note.textContent = 'You subscribed with ' + GUEST_CLAIM + ' — this link is yours.';
  }

  /* 订阅状态回显：让客户看见"三块已经通了"，不用自己猜 */
  function markSubscribed() {
    var note = document.querySelector('#bbr-root .bbr-bindnote');
    if (note && !GUEST_CLAIM) {
      // 登录即订阅（2026-10-30 侯哥定）⇒ 必须让客户看得见，并知道随时能退
      note.textContent = '✓ You are on our new-drop emails. 10% comes off automatically at checkout. Unsubscribe anytime.';
    }
  }

  function fillLink(d) {
    var el = $('#bbr-link');
    if (!el) return;
    /* 未登录：链接位与按钮由 liquid 输出的锁定态 <a> 负责（点一下就去登录）。
       这里绝不接管，否则会把「Sign in to get your link」变成分享一个拿不到奖励的空链接 */
    if (!EMAIL) return;
    var anon = anonId();
    var anonLink = location.origin + '/?ref=' + encodeURIComponent(anon) + '&utm_source=share';

    function paint(u) { el.textContent = u; }

    /* 登录用户：先显示"生成中"，等 /bind 返回正式码再填 ——
       否则客户可能在 0.5 秒内复制到匿名链接，那笔单归不到他（2026-10-29） */
    paint(EMAIL ? (S.copy['link_creating'] || 'Creating your link…') : anonLink);

    /* 登录了就把它换成"系统认得的码"并绑邮箱 ——
       否则朋友下单时查不到你是谁，返利和赠卡都归不到你头上（2026-10-29） */
    if (EMAIL) {
      S.bindTries = (S.bindTries || 0) + 1;
      req('/bind', { method: 'POST', timeout: 15000,
                     body: { anon_id: anon, email: EMAIL, subscribe: !GUEST_CLAIM } })
        .then(function (r) {
          if (r.ok && r.data && r.data.link) {
            paint(r.data.link);
            S.link = r.data.link;
            S.code = r.data.code || S.code;
            S.bindErr = '';
            showLinkErr('');
            unlockGuestUi();
            if (r.data.subscribed === 'subscribed') markSubscribed();
            applyPoster();
            preloadPoster();
            if (S.pendingShare || S.wantSheet) {
              S.pendingShare = false; S.wantSheet = false; openShareSheet();
            }
          } else {
            linkFailed((r.data && (r.data.error || r.data.message)) || ('HTTP ' + r.status));
          }
        })
        .catch(function (e) {
          linkFailed((e && e.name === 'AbortError') ? 'timeout' : ((e && e.message) || 'network'));
        });
    }

    /* 建码失败：绝不能让链接位一直挂着「Creating…」（客户会以为坏了）。
       改成一句可点的重试文案，并把原因写进隐藏字段方便排查（2026-10-29） */
    function linkFailed(why) {
      S.bindErr = String(why || '').slice(0, 120);
      if (S.link) return;                       // 已经有正式链接就不打扰
      if (S.bindTries >= 3) {
        paint('Link unavailable — please refresh the page');
      } else if (S.bindTries === 1) {
        /* 第一次失败先自己再试一遍（服务器其实常常已经建好码，只是响应没赶上），
           客户不用手点，等 1.5 秒就好 —— 这才是"点了就出来"的体验 */
        paint(S.copy['link_creating'] || 'Creating your link…');
        setTimeout(function () { if (!S.link) { S.bindTries += 1; fillLink(null); } }, 1500);
        return;
      } else {
        paint(S.copy['link_retry'] || 'Could not create your link — tap to retry');
      }
      el.setAttribute('data-retry', '1');
      el.style.cursor = 'pointer';
      el.onclick = function () {
        if (S.bindTries >= 3) return;
        el.onclick = null;
        el.removeAttribute('data-retry');
        el.style.cursor = '';
        paint(S.copy['link_creating'] || 'Creating your link…');
        fillLink(null);
      };
      showLinkErr('Connection problem (' + S.bindErr + ')');
    }

    /* 把失败原因固定显示在链接框下面（原来塞进深色卡的说明位，被弹层/滚动挡住看不见） */
    function showLinkErr(msg) {
      var box = $('#bbr-linkerr');
      if (!box) {
        box = document.createElement('div');
        box.id = 'bbr-linkerr';
        box.style.cssText = 'margin-top:6px;font-size:10.5px;line-height:1.5;color:#c0392b;word-break:break-all';
        if (el.parentNode) el.parentNode.appendChild(box);
      }
      box.textContent = msg || '';
      box.hidden = !msg;
    }

    var cp = $('#bbr-copy');
    if (cp) cp.onclick = function () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(el.textContent)
          .then(function () { toast('Link copied'); }, function () { toast('Copy failed'); });
      } else { toast(el.textContent); }
    };
    var sh = $('#bbr-share');
    if (sh) sh.onclick = openShareSheet;
  }

  /* ---------------- 小工具 ---------------- */
  function setText(sel, v) { var el = $(sel); if (el) el.textContent = v; }
  function setStyle(sel, prop, v) { var el = $(sel); if (el) el.style[prop] = v; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  var toastT = null;
  function toast(msg) {
    var t = $('#bbr-toast');
    if (!t) { t = document.createElement('div'); t.id = 'bbr-toast'; t.className = 'bbr-toast'; root.appendChild(t); }
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, 2200);
  }

  /* ---------------- 启动 ---------------- */
  function boot() {
    try { S.zip = localStorage.getItem('bb_gift_zip') || ''; } catch (e) {}
    /* 未登录也照常请求 —— 拿文案/参数/分享链接，余额为空而已。
       之前这里 !EMAIL 直接 fail，导致游客看到的是空壳页（2026-10-29 修） */
    req('/rewards' + (EMAIL ? '?email=' + encodeURIComponent(EMAIL) : ''))
      .then(function (r) {
        if (!r.ok) { fail((r.data && r.data.error) || 'Could not load your rewards'); return; }
        S.data = r.data;
        fillLink(r.data);
        if (!S.zip) {
          // 没有邮编就用客户默认地址的（liquid 带过来），再不行留空让客户填
          S.zip = (root.getAttribute('data-zip') || '').replace(/\D/g, '').slice(0, 5);
        }
        render();
      })
      .catch(function (e) {
        /* 瞬断（手机切网 / 服务器重启）自动重试一次，别直接给客户看错误 */
        S.bootTries = (S.bootTries || 0) + 1;
        if (S.bootTries <= 1) { setTimeout(boot, 1200); return; }
        fail('Could not load your rewards');
      });
  }

  /* 接口彻底挂了也要把页面填满，不能停在 Loading… */
  function fail(msg) {
    S.failed = true;
    fillLink(null);
    setText('[data-k="state"]', S.copy['state_none'] || 'Not started');
    var btn = $('#bbr-main');
    if (btn) {
      btn.disabled = false;
      if (!EMAIL) {                      /* 未登录：按钮永远是"去登录" */
        btn.textContent = S.copy['btn_signin'] || 'Get my link';
        btn.setAttribute('data-act', 'signin');
      } else {
        btn.textContent = S.copy['btn_share'] || 'Share my link';
        btn.setAttribute('data-act', 'share');
      }
    }
    var note = $('#bbr-note');
    if (note) note.textContent = !EMAIL
      ? (S.copy['signin_hint'] || 'One quick sign-in — your link is created automatically.')
      : '';   /* 登录后才把这里留给运费/锁定说明 */
    /* 好友区也补个空态：接口挂了不能留一个空框 */
    var tb0 = $('[data-k="history"]');
    if (tb0 && !tb0.innerHTML) tb0.innerHTML = '<div class="bbr-empty">No friends yet — send your link to start earning.</div>';
    var box = $('#bbr-boot');
    if (box) { box.hidden = false; box.innerHTML = esc(msg) + ' · <button type="button" id="bbr-retry">Try again</button>';
      var r = $('#bbr-retry'); if (r) r.onclick = function () { location.reload(); }; }
    paintCopy();
    return true;
  }

  /* REWARDS-SHEET-20261103（侯哥 11-03 12:41）：「点 Earn free cards 也从底部弹窗出来里面的页面内容」
     首页弹窗是 fetch 完再把本 section 连脚本一起注入的 —— 那时 DOMContentLoaded 早就过了，
     原来的写法只挂 DOMContentLoaded ⇒ 脚本 200 加载了却一行没跑，接口一个请求都没发（实测）。
     改成 init() 可重入 ＋ readyState 兜底：正常页面走 DOMContentLoaded，动态插入走立即执行。 */
  var inited = false;
  function init() {
    if (inited) return;
    if (!$('#bbr-link')) return;
    inited = true;
    S.pendingShare = /[?&]share=1/.test(location.search);
    // 分享链接：优先用接口给的 code，退化为当前站点 + ?ref=
    bind();
    boot();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 链接文案单独处理（不是纯文本替换）
  window.addEventListener('bbr-link-ready', function () {});

  // 暴露给 liquid 里可能在 DOMContentLoaded 之后插入的情况
  /* 暴露少量调试钩子：弹层/分段只能由登录态触发，QA 与线上排障需要一个入口
     （只读+切面板，不涉及任何写操作，2026-10-30 加）*/
  window.BBR = { boot: boot, state: S, tabs: bindTabs, pane: showPane, sheet: openShareSheet,
                 poster: applyPoster, close: closeShareSheet, preload: preloadPoster };
})();
